// This file is used to map the fields for the Utah's NGL Enrollment Form
import { getNGLFieldNames } from '@/components/documents/Foxit/FormMapping/FieldNameProviders/NGLFieldNameProvider'
import { useFormFillHelper } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { useIdentitySetup } from '@/components/documents/Foxit/FormMapping/composables/IdentityFields'
import { usePaymentSetup } from '@/components/documents/Foxit/FormMapping/composables/PaymentFields'

export default class NGLUTEnrollmentForm {
	private fieldNameProvider = getNGLFieldNames()

	// Standard list of fields for this form.
	// These values point to field names in the fieldNameProvider, as well as functions to get the value for the field via the fieldsValueProvider
	private fields: (keyof typeof this.fieldNameProvider)[] = [
		// Insured
		'insuredFirstName',
		'insuredMiddleInitial',
		'insuredLastName',
		'insuredMaleCheck',
		'insuredFemaleCheck',
		'insuredDateOfBirth',
		'insuredAge',
		'insuredSSN',

		// Policy Owner
		'policyOwnerFields',

		// Purchaser Contact (Mailing Address)
		'purchaserAddress',
		'purchaserEmail',
		'purchaserPhone',
		'purchaserSecondaryPhone',
		'purchaserZip',
		'purchaserState',
		'purchaserCity',

		// Beneficiary
		'beneficiaryName',
		'beneficiaryRelationship',

		// Funeral Home
		'funeralHomeName',
		'funeralHomeZip',
		'purchaserCityState',
		'funeralHomeRepresentativePrintedName',
		'funeralHomeRepresentativeProducerNumber',

		// Payment Term
		'paymentTermChecks',

		// Payment Mode
		'paymentModeFields',

		// Payment Amount
		'paymentAmountFields',
	]

	private unfilledFields = [
		'healthQuestions1YesUTCheck',
		'healthQuestions1NoUTCheck',
		'healthQuestions2YesUTCheck',
		'healthQuestions2NoUTCheck',
		'applicantReplacement1YesCheck',
		'applicantReplacement1NoCheck',
		'applicantReplacement2YesCheck',
		'applicantReplacement2NoCheck',
		'agentReplacement1YesCheck',
		'agentReplacement1NoCheck',
		'agentReplacement2YesCheck',
		'agentReplacement2NoCheck',
		'appointmentCode',
	]

	constructor(planHolderId: string) {
		const { setFieldNameProvider } = useFormFillHelper()
		const { identitySetup } = useIdentitySetup()
		const { paymentSetup } = usePaymentSetup()

		identitySetup(planHolderId, ['planHolder', 'funeralHome', 'salesContact'])
		paymentSetup(planHolderId, ['paymentDetails'])
		setFieldNameProvider(this.fieldNameProvider)
	}

	getFormMappings() {
		const { formatFields, mapFields } = useFormFillHelper()
		const values = mapFields(this.fields)

		return formatFields(values)
	}
}
